import classnames from 'classnames';
import React from 'react';

import { Icon, IconTypes } from '@eika/icon';
import '@eika/tag-style';

import { TagProps, TagTypes } from './types';

const LIVE_TYPES: TagTypes[] = ['error', 'attention', 'success'];

const Tag = ({
    children,
    icon,
    type = 'default',
    size = 'standard',
    className,
    show = true,
    ...rest
}: TagProps): React.JSX.Element => {
    const targetIcon = type === 'warning' && !icon ? IconTypes.UTROPSTEGN_24 : icon;
    return (
        <span
            aria-live={LIVE_TYPES.includes(type) ? 'polite' : 'off'}
            className={classnames('sgw-tag__container', className, {
                'sgw-tag--visibility-hidden': !show || !children,
            })}
        >
            <span
                className={classnames('sgw-tag', `sgw-tag--${type}`, `sgw-tag--${size}`, type, `${type}--${size}`, {
                    'sgw-tag--error-severe': 'severe' in rest && rest.severe,
                    'sgw-tag--hidden': !show,
                })}
                {...rest}
            >
                {targetIcon && children && <Icon type={targetIcon} />}
                <span className="sgw-tag__content">
                    {children}
                    {type === 'external-link' && 'url' in rest && 'linkText' in rest && (
                        <a
                            className="sgw-tag__external-link"
                            href={rest.url}
                            target={rest.anchorTarget}
                            rel={rest.anchorTarget ? 'noopener' : undefined}
                        >
                            {rest.linkText}
                            <span className="sgw-tag__external-link__icon-container">
                                <Icon type={IconTypes.ExternalLink} />
                            </span>
                        </a>
                    )}
                </span>
            </span>
        </span>
    );
};

export default Tag;
